// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import '../src/assets/css/bootstrap.min.css';
import '../src/assets/css/owl.carousel.min.css';
import '../src/assets/css/owl.theme.default.min.css';
import '../src/assets/css/animate.min.css';
import '../src/assets/css/smooth-scrollbar.css';
import '../src/assets/css/lightbox.min.css';
import '../src/assets/css/style.css';
import '../src/assets/css/responsive.css';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import Layout from './components/Layout'; // Import the Layout component
import Home from './pages/Home/Home';
import PortfolioDetail from './pages/Details/PortfolioDetail';

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/project/:projectId" element={<PortfolioDetail />} />
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;


// import React from 'react';

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import './App.css';
// import '../src/assets/css/bootstrap.min.css';
// import '../src/assets/css/owl.carousel.min.css';
// import '../src/assets/css/owl.theme.default.min.css';
// import '../src/assets/css/animate.min.css';
// import '../src/assets/css/smooth-scrollbar.css';
// import '../src/assets/css/lightbox.min.css';
// import '../src/assets/css/style.css';
// import '../src/assets/css/responsive.css';

// import Home from './pages/Home/Home';

// import LeftSidebar from './components/SideBar/LeftSidebar';
// import MenuScrollNav from './Menus/MenuScrollNav';
// import SidebarMenu from './components/SideBar/SidebarMenu';
// import PortfolioDetail from './pages/Details/PortfolioDetail';

// function App() {
//     return (
//         <Router>
//             <div className="responsive-sidebar-menu">
//                 <SidebarMenu />
//             </div>
//             <MenuScrollNav />
//             <LeftSidebar />
//             <main className="dev-main">
//                 <div id="smooth-wrapper">
//                     <div id="smooth-content">
//                         <Routes>
//                             <Route path="/" element={<Home />} />
//                             <Route path="/project/:projectId" element={<PortfolioDetail />} />
//                         </Routes>
//                     </div>
//                 </div>
//             </main>
//         </Router>
//     );
// }

// export default App;


